import script from "./settingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./settingsPage.vue?vue&type=script&setup=true&lang=js"

import "./settingsPage.vue?vue&type=style&index=0&id=00ce3c12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ce3c12"]])

export default __exports__